<template>
    <div class="box">
        <article class="media">
            <div class="media-content">
                <div class="content has-text-centered">
                    <p class="total has-text-primary">0$</p>
                </div>
                <nav class="level is-mobile" style="word-wrap: break-word; display: inline-block;">
                    <div class="level-left" style="display: inline-block;">
                        <a class="level-item">
                            Here is your bonus founds that you will earn while working with us.
                        </a>
                    </div>
                </nav>
            </div>
        </article>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        mounted () {

        }
    }
</script>

<style scoped>
    .box {
        background: url('../../assets/bonus.png') center;
        min-height: 175px;
    }
    .total {
        font-size: 4rem;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Coupon.vue